var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 78,
    viewBox: "0 0 176 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.451 55.9102C171.277 55.9102 172.725 56.4497 173.796 57.5289C174.885 58.608 175.429 60.1068 175.429 62.0253V70.4016H170.952V62.6163C170.952 61.6913 170.697 60.9804 170.188 60.4837C169.697 59.9698 169.012 59.7129 168.134 59.7129C167.256 59.7129 166.563 59.9698 166.054 60.4837C165.562 60.9804 165.317 61.6913 165.317 62.6163V70.4016H160.84V62.6163C160.84 61.6913 160.585 60.9804 160.076 60.4837C159.585 59.9698 158.9 59.7129 158.022 59.7129C157.144 59.7129 156.451 59.9698 155.942 60.4837C155.45 60.9804 155.204 61.6913 155.204 62.6163V70.4016H150.701V56.0643H155.204V57.8629C155.661 57.2634 156.258 56.7923 156.995 56.4497C157.732 56.09 158.566 55.9102 159.497 55.9102C160.603 55.9102 161.586 56.1414 162.446 56.6039C163.324 57.0664 164.009 57.7259 164.5 58.5823C165.009 57.7944 165.703 57.152 166.581 56.6553C167.458 56.1585 168.415 55.9102 169.451 55.9102Z",
    fill: "url(#paint0_linear_360_8776)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.327 63.0043C148.327 63.4154 148.301 63.8436 148.248 64.289H138.057C138.127 65.1797 138.417 65.8649 138.926 66.3445C139.453 66.807 140.093 67.0382 140.848 67.0382C141.972 67.0382 142.753 66.5757 143.192 65.6508H147.985C147.739 66.5929 147.291 67.4408 146.642 68.1945C146.01 68.9481 145.211 69.5391 144.245 69.9673C143.28 70.3956 142.2 70.6097 141.006 70.6097C139.567 70.6097 138.285 70.3099 137.161 69.7104C136.038 69.1109 135.16 68.2544 134.528 67.141C133.896 66.0276 133.58 64.7258 133.58 63.2355C133.58 61.7453 133.887 60.4434 134.502 59.33C135.134 58.2166 136.012 57.3601 137.135 56.7606C138.259 56.1611 139.549 55.8613 141.006 55.8613C142.428 55.8613 143.692 56.1525 144.798 56.7349C145.904 57.3173 146.765 58.1481 147.379 59.2272C148.011 60.3064 148.327 61.5654 148.327 63.0043ZM143.719 61.848C143.719 61.0943 143.455 60.4948 142.929 60.0495C142.402 59.6041 141.744 59.3814 140.954 59.3814C140.199 59.3814 139.558 59.5955 139.031 60.0238C138.522 60.452 138.206 61.0601 138.083 61.848H143.719Z",
    fill: "url(#paint1_linear_360_8776)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.965 66.6782V70.4039H129.674C128.041 70.4039 126.768 70.0185 125.855 69.2476C124.942 68.4597 124.486 67.1835 124.486 65.4192V59.7151H122.695V56.0666H124.486V52.5723H128.989V56.0666H131.939V59.7151H128.989V65.4706C128.989 65.8988 129.094 66.2072 129.305 66.3956C129.516 66.584 129.867 66.6782 130.358 66.6782H131.965Z",
    fill: "url(#paint2_linear_360_8776)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.069 70.6097C113.787 70.6097 112.646 70.3956 111.645 69.9673C110.644 69.5391 109.854 68.9567 109.275 68.2202C108.696 67.4665 108.371 66.6271 108.301 65.7021H112.751C112.804 66.1989 113.041 66.6014 113.462 66.9098C113.884 67.2181 114.401 67.3723 115.016 67.3723C115.578 67.3723 116.008 67.2695 116.306 67.0639C116.622 66.8412 116.78 66.5586 116.78 66.216C116.78 65.8049 116.561 65.5052 116.122 65.3167C115.683 65.1112 114.972 64.8885 113.989 64.6487C112.936 64.4089 112.058 64.1605 111.356 63.9036C110.653 63.6295 110.048 63.2098 109.538 62.6446C109.029 62.0622 108.775 61.2828 108.775 60.3064C108.775 59.4842 109.003 58.7391 109.459 58.071C109.933 57.3858 110.618 56.8463 111.514 56.4523C112.426 56.0583 113.506 55.8613 114.753 55.8613C116.596 55.8613 118.044 56.3067 119.098 57.1974C120.169 58.0881 120.783 59.2701 120.941 60.7432H116.78C116.71 60.2464 116.482 59.8525 116.096 59.5613C115.727 59.2701 115.235 59.1245 114.621 59.1245C114.094 59.1245 113.69 59.2272 113.41 59.4328C113.129 59.6212 112.988 59.8867 112.988 60.2293C112.988 60.6404 113.208 60.9487 113.647 61.1543C114.103 61.3598 114.805 61.5654 115.753 61.771C116.842 62.045 117.728 62.3191 118.413 62.5932C119.098 62.8501 119.695 63.2783 120.204 63.8779C120.73 64.4603 121.003 65.2482 121.02 66.2417C121.02 67.0811 120.774 67.8347 120.283 68.5028C119.809 69.1537 119.115 69.6676 118.202 70.0444C117.307 70.4213 116.262 70.6097 115.069 70.6097Z",
    fill: "url(#paint3_linear_360_8776)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.46 56.0684L98.2434 77.2145H93.3981L96.7687 69.9174L90.791 56.0684H95.8208L99.2177 65.0356L102.588 56.0684H107.46Z",
    fill: "url(#paint4_linear_360_8776)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9382 70.5834C81.5864 70.5834 80.375 70.3692 79.3041 69.941C78.2332 69.5128 77.3729 68.879 76.7234 68.0397C76.0913 67.2003 75.7578 66.1897 75.7227 65.0078H80.5154C80.5857 65.6758 80.8227 66.1897 81.2265 66.5494C81.6302 66.892 82.1569 67.0633 82.8065 67.0633C83.4736 67.0633 84.0003 66.9177 84.3865 66.6265C84.7728 66.3182 84.9659 65.8985 84.9659 65.3675C84.9659 64.9221 84.8079 64.5538 84.4919 64.2626C84.1934 63.9714 83.816 63.7316 83.3595 63.5432C82.9206 63.3548 82.2886 63.1407 81.4635 62.9008C80.2697 62.5411 79.2953 62.1814 78.5404 61.8217C77.7855 61.462 77.1359 60.931 76.5917 60.2287C76.0474 59.5264 75.7753 58.6099 75.7753 57.4794C75.7753 55.8007 76.3986 54.4903 77.645 53.5482C78.8915 52.589 80.5154 52.1094 82.5168 52.1094C84.5533 52.1094 86.1948 52.589 87.4413 53.5482C88.6877 54.4903 89.3549 55.8093 89.4427 57.5051H84.5709C84.5358 56.9227 84.3163 56.4688 83.9125 56.1433C83.5087 55.8007 82.9908 55.6294 82.3588 55.6294C81.8146 55.6294 81.3757 55.775 81.0421 56.0662C80.7086 56.3403 80.5418 56.7428 80.5418 57.2739C80.5418 57.8563 80.8227 58.3102 81.3845 58.6356C81.9463 58.9611 82.8241 59.3123 84.0179 59.6891C85.2117 60.0831 86.1772 60.4599 86.9146 60.8196C87.6695 61.1793 88.3191 61.7018 88.8633 62.387C89.4075 63.0721 89.6797 63.9543 89.6797 65.0335C89.6797 66.0612 89.4075 66.9948 88.8633 67.8341C88.3366 68.6734 87.5642 69.3415 86.5459 69.8382C85.5277 70.335 84.3251 70.5834 82.9382 70.5834Z",
    fill: "url(#paint5_linear_360_8776)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.59 70.6097C59.1504 70.6097 57.8513 70.3099 56.6926 69.7104C55.5515 69.1109 54.6473 68.2544 53.9802 67.141C53.3306 66.0276 53.0059 64.7258 53.0059 63.2355C53.0059 61.7624 53.3394 60.4691 54.0065 59.3557C54.6737 58.2252 55.5866 57.3601 56.7453 56.7606C57.904 56.1611 59.2031 55.8613 60.6427 55.8613C62.0823 55.8613 63.3814 56.1611 64.5401 56.7606C65.6988 57.3601 66.6117 58.2252 67.2789 59.3557C67.946 60.4691 68.2796 61.7624 68.2796 63.2355C68.2796 64.7086 67.9372 66.0105 67.2525 67.141C66.5854 68.2544 65.6637 69.1109 64.4875 69.7104C63.3288 70.3099 62.0296 70.6097 60.59 70.6097ZM60.59 66.807C61.4503 66.807 62.1789 66.4987 62.7758 65.882C63.3902 65.2653 63.6974 64.3832 63.6974 63.2355C63.6974 62.0878 63.399 61.2057 62.8021 60.589C62.2227 59.9724 61.503 59.664 60.6427 59.664C59.7649 59.664 59.0363 59.9724 58.457 60.589C57.8776 61.1886 57.588 62.0707 57.588 63.2355C57.588 64.3832 57.8689 65.2653 58.4307 65.882C59.01 66.4987 59.7298 66.807 60.59 66.807Z",
    fill: "url(#paint6_linear_360_8776)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5324 58.0968C40.9538 57.4287 41.5594 56.8891 42.3494 56.478C43.1395 56.0669 44.0436 55.8614 45.0618 55.8614C46.2732 55.8614 47.3705 56.1611 48.3536 56.7607C49.3367 57.3602 50.1092 58.2167 50.671 59.3301C51.2503 60.4435 51.54 61.7368 51.54 63.2099C51.54 64.683 51.2503 65.9848 50.671 67.1154C50.1092 68.2288 49.3367 69.0938 48.3536 69.7105C47.3705 70.31 46.2732 70.6098 45.0618 70.6098C44.026 70.6098 43.1219 70.4128 42.3494 70.0188C41.577 69.6077 40.9713 69.0681 40.5324 68.4001V70.4042H36.0293V51.3906H40.5324V58.0968ZM46.9579 63.2099C46.9579 62.1136 46.6419 61.2571 46.0099 60.6405C45.3954 60.0067 44.6317 59.6898 43.7188 59.6898C42.8235 59.6898 42.0598 60.0067 41.4278 60.6405C40.8133 61.2743 40.5061 62.1393 40.5061 63.2356C40.5061 64.3318 40.8133 65.1969 41.4278 65.8307C42.0598 66.4644 42.8235 66.7813 43.7188 66.7813C44.6142 66.7813 45.3778 66.4644 46.0099 65.8307C46.6419 65.1797 46.9579 64.3062 46.9579 63.2099Z",
    fill: "url(#paint7_linear_360_8776)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6513 63.0043C33.6513 63.4154 33.625 63.8436 33.5723 64.289H23.3811C23.4513 65.1797 23.741 65.8649 24.2501 66.3445C24.7768 66.807 25.4176 67.0382 26.1725 67.0382C27.296 67.0382 28.0773 66.5757 28.5162 65.6508H33.309C33.0632 66.5929 32.6155 67.4408 31.9659 68.1945C31.3339 68.9481 30.5351 69.5391 29.5695 69.9673C28.604 70.3956 27.5243 70.6097 26.3305 70.6097C24.8909 70.6097 23.6093 70.3099 22.4857 69.7104C21.3621 69.1109 20.4843 68.2544 19.8523 67.141C19.2203 66.0276 18.9043 64.7258 18.9043 63.2355C18.9043 61.7453 19.2115 60.4434 19.826 59.33C20.458 58.2166 21.3358 57.3601 22.4594 56.7606C23.583 56.1611 24.8733 55.8613 26.3305 55.8613C27.7525 55.8613 29.0165 56.1525 30.1226 56.7349C31.2286 57.3173 32.0888 58.1481 32.7033 59.2272C33.3353 60.3064 33.6513 61.5654 33.6513 63.0043ZM29.0429 61.848C29.0429 61.0943 28.7795 60.4948 28.2529 60.0495C27.7262 59.6041 27.0678 59.3814 26.2778 59.3814C25.5229 59.3814 24.8821 59.5955 24.3554 60.0238C23.8463 60.452 23.5303 61.0601 23.4074 61.848H29.0429Z",
    fill: "url(#paint8_linear_360_8776)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5377 70.4025H12.0346L4.50311 59.2769V70.4025H0V52.3652H4.50311L12.0346 63.5421V52.3652H16.5377V70.4025Z",
    fill: "url(#paint9_linear_360_8776)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6292 0H66.8457V42.1701L110.066 0H97.6588L75.7358 21.1324V9.55013L85.6292 0Z",
    fill: "url(#paint10_linear_360_8776)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6036 33.4097L78.7998 42.1701H110.066V11.3085L101.262 19.9005V33.4097H87.6036Z",
    fill: "url(#paint11_linear_360_8776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_8776",
    x1: -2.31822,
    y1: 61.1229,
    x2: 177.631,
    y2: 61.1229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_8776",
    x1: -2.31633,
    y1: 61.1257,
    x2: 177.632,
    y2: 61.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_360_8776",
    x1: -2.31779,
    y1: 61.1257,
    x2: 177.631,
    y2: 61.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_360_8776",
    x1: -2.31794,
    y1: 61.1257,
    x2: 177.631,
    y2: 61.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_360_8776",
    x1: -2.32021,
    y1: 61.1271,
    x2: 177.629,
    y2: 61.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_360_8776",
    x1: -2.31921,
    y1: 61.125,
    x2: 177.63,
    y2: 61.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_360_8776",
    x1: -2.31945,
    y1: 61.1257,
    x2: 177.629,
    y2: 61.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_360_8776",
    x1: -2.31879,
    y1: 61.1255,
    x2: 177.63,
    y2: 61.1255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_360_8776",
    x1: -2.32072,
    y1: 61.1257,
    x2: 177.628,
    y2: 61.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_360_8776",
    x1: -2.31885,
    y1: 61.1243,
    x2: 177.63,
    y2: 61.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_360_8776",
    x1: 88.4559,
    y1: 0,
    x2: 88.4559,
    y2: 42.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_360_8776",
    x1: 88.4559,
    y1: 0,
    x2: 88.4559,
    y2: 42.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c2823cdd8609d6882ae8cb65a1c72005.svg";
export { ForwardRef as ReactComponent };